import React, { useEffect, useRef, useState, useContext } from "react";
import "./ReplayApp.scss";
import { useTranslation } from "react-i18next";
import PerfectScrollbar from "react-perfect-scrollbar";
import i18n from "i18next";

import OwnerInfos from "./OwnerInfos";
import Comments from "./Comments";
import Infos from "./Infos";
import ReplayHand from "../../api/ReplayHand";
import ScrollToTop from "../components/ScrollToTop";
import GATracker from "../components/GATracker";
import LastReplaysSensor from "./LastReplaysSensor";
import Votes from "./Votes";
import HandSummary from "./HandSummary";
import AdContainer from "../ads/AdContainer";
import { LoadingContext } from "../../api/loading/LoadingContext";
import { UserContext } from "../../api/user/userContext";
import XeesterUser from "../../api/user/User";
import { FullScreen, useFullScreenHandle } from "react-full-screen";

import CircleLoader from "react-spinners/CircleLoader";

function ReplayApp({ match, location, history, onShowLogin }) {
  const { user, dispatchUser } = useContext(UserContext);
  const [replayId, setReplayId] = useState("");
  const [hand, setHand] = useState(new ReplayHand());
  const [replayUrl, setReplayUrl] = useState(null);
  const { loading, dispatchLoading } = useContext(LoadingContext);
  const [fullscreenChange, setFullscreenChange] = useState((st) => {console.log("st") });

  const scrollbarRef = useRef();
  const _scrollbarRef = React.createRef();

  const onDataUpdated = () => {
    if (_scrollbarRef.current !== null) {
      _scrollbarRef.current.updateScroll();
    }
  };
  const previewClicked = () => {
    if (scrollbarRef.current !== null) {
      scrollbarRef.current.scrollTop = 0;
      _scrollbarRef.current.updateScroll();
    }
  };

  const onSubscribed = (response) => {
    if (response.error !== 401) {
      let _hand = new ReplayHand();
      Object.assign(_hand, hand);
      _hand.subscribed = response.subscribed;
      setHand(_hand);
      let _user = XeesterUser.from(user);
      Object.assign(_user, { subscriptions: response.subscriptions });
      dispatchUser({ type: "update", payload: _user });
    } else {
      dispatchUser({ type: "disconnect" });
    }
  };

  const onVisibility = (visibility) => {
    let _hand = new ReplayHand();
    Object.assign(_hand, hand);
    _hand.visibility = visibility;
    setHand(_hand);
  };

  const onComment = (comment) => {
    let _hand = new ReplayHand();
    Object.assign(_hand, hand);
    _hand.comments.splice(0, 0, comment);
    _hand.nb_comments++;
    setHand(_hand);
  };

  const onVoted = (resp) => {
    let _hand = new ReplayHand();
    Object.assign(_hand, hand);
    _hand.vote = resp.vote;
    _hand.votes = resp.votes;
    _hand.vote1 = resp.vote1;
    _hand.vote2 = resp.vote2;
    _hand.vote3 = resp.vote3;
    _hand.vote4 = resp.vote4;
    setHand(_hand);
  };

  const { t } = useTranslation();

  window.replayerScrolled = (evt) => {
    if (scrollbarRef.current) {
      if (evt.deltaMode === 1) {
        //Firefox->Line mode
        scrollbarRef.current.scrollTop += evt.deltaY * 38;
      } else {
        scrollbarRef.current.scrollTop += evt.deltaY;
      }
      _scrollbarRef.current.updateScroll();
    }
  };

  const handle = useFullScreenHandle();
 
  window.enterFullscreen = (reportChange) =>
  {
    console.log("entering", reportChange);
    setFullscreenChange(reportChange);
    handle.enter();
  }
  window.exitFullscreen = (reportChange) =>
  {
    console.log("exiting", reportChange);
    setFullscreenChange(reportChange);
    handle.exit();
  }


  useEffect(() => {
    //FETCH HAND DETAILS
    //console.log("replayerapp effect", match.params.id);
    const _replayId = match.params.id;

    if (_replayId !== null && _replayId.length > 0 && _replayId !== replayId) {
      //console.log("fetching");
      dispatchLoading({ type: "update", payload: 10 });
      setReplayId((r) => _replayId);
      let url = window.serverUrl+"/social/details.php?id=" + _replayId;
      fetch(url)
        .then((r) => r.json())
        .then((_data) => {
          dispatchLoading({ type: "update", payload: 50 });
          let _hand = ReplayHand.from(_data);
          setHand((h) => _hand);
          let _replayUrl = "/opencards/" + i18n.language + "/a/" + _replayId;
          setReplayUrl((r) => _replayUrl);
          setTimeout(() => {
            dispatchLoading({ type: "update", payload: 100 });
          }, 500);
        })
        .catch((err) => {
          dispatchLoading({ type: "update", payload: 100 });
          console.error("fetch problem", err);
        });
      return () => {
        //console.log("replayapp done");
      };
    } else {
      return () => {
        //console.log("replayapp done");
      };
    }
  }, [match.params.id, hand.id, replayId, dispatchLoading]);

  return (
    <>
      <GATracker></GATracker>
      <ScrollToTop></ScrollToTop>
      <PerfectScrollbar
        ref={_scrollbarRef}
        containerRef={(el) => (scrollbarRef.current = el)}
        className="replay-scroll main-scroll"
      >
        <div className="full">
          <div className={"replay-app d-flex"}>
            <div className="center-container d-flex flex-column">
              <div className="replayer-container">
                {hand !== null && hand.id !== null ? (
                  hand.error !== 401 &&
                  hand.error !== 404 &&
                  replayId !== null &&
                  loading.progress === 100 ? (
                      <FullScreen handle={handle} onChange={(state, _handle) => { fullscreenChange?fullscreenChange(state):console.log("no handler"); }}>
                    <iframe
                      id="_replayer"
                      title="Xeester Replayer"
                      sandbox="allow-top-navigation allow-scripts allow-same-origin allow-forms" 
                      src={replayUrl}
                      frameBorder="0"
                      allowFullScreen
                    ></iframe>
                  </FullScreen>
                  ) : hand.error === 401 ? (
                    <div
                      id="_replayer"
                      className="replayer-not-allowed d-flex align-items-center"
                    >
                      <div className="message d-flex ">
                        <span className="m-auto">{t("not_allowed")}</span>
                      </div>
                    </div>
                  ) : loading.progress === 100 ? (
                    <div
                      id="_replayer"
                      className="replayer-not-allowed d-flex align-items-center"
                    >
                      <div className="message d-flex ">
                        <span className="m-auto">{t("not_exists")}</span>
                      </div>
                    </div>
                  ) : (
                    <div className="loading-container">
                      <CircleLoader  color="#FFF" size={150}/>
                    </div>
                  )
                ) : (
                  <div className="loading-container">
                    <CircleLoader  color="#FFF" size={150}/>
                  </div>
                )}
              </div>
              {hand !== null ? (
                hand.error !== 401 &&
                hand.error !== 404 &&
                loading.progress === 100 ? (
                  <div className="bottom">
                    <Infos
                      hand={hand}
                      onLogin={onShowLogin}
                      onVoted={onVoted}
                    ></Infos>
                    <OwnerInfos
                      history={history}
                      hand={hand}
                      onSubscribed={onSubscribed}
                      onShowLogin={onShowLogin}
                      onVisibility={onVisibility}
                    ></OwnerInfos>
                    {/* v2-1438 step 3: the hand as text, what search engines read of it */}
                    <HandSummary hand={hand}></HandSummary>
                    <Votes
                      hand={hand}
                      onLogin={onShowLogin}
                      onVoted={onVoted}
                    ></Votes>
                    <Comments
                      hand={hand}
                      onLogin={onShowLogin}
                      onComment={onComment}
                    ></Comments>
                  </div>
                ) : (
                  <></>
                )
              ) : (
                <div className="loading-container">
                  <CircleLoader  color="#FFF" size={150}/>
                </div>
              )}
            </div>
            <div className="related ">
              <AdContainer location={location}></AdContainer>
              <section>{t("replayApp.related")}</section>
              {hand.id !== null ? (
                <div className="replays d-flex flex-column">
                  <LastReplaysSensor
                    replayId={hand.id}
                    onDataUpdated={onDataUpdated}
                    onClicked={previewClicked}
                  ></LastReplaysSensor>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </PerfectScrollbar>
      </>
  );
}

export default ReplayApp;
